<template>
  <e-charts
    ref="line"
    autoresize
    :options="option"
    theme="theme-color"
    auto-resize
  />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/line'
import theme from './themeLineDB.json'

ECharts.registerTheme('theme-color', theme)

export default {
  components: {
    ECharts,
  },
  props: {
    optionData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      option: {
        title: {
          text: '',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985',
            },
          },
          // formatter(d) {
          //   return `${d[0].name} : ${d[0].data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} คัน`
          // },
        },
        legend: {
          left: '0',
          textStyle: {
            fontSize: 16,
            color: '#fff',
          },
        },
        grid: {
          width: '85%',
          left: '60px',
          right: '4%',
          containLabel: false,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.optionData.xAxisData,
            axisLabel: {
              hideOverlap: true,
              show: true,
              fontSize: 16,
              color: '#fff',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: { show: false },
            axisLabel: {
              hideOverlap: true,
              show: true,
              fontSize: 16,
              color: '#fff',
            },
          },
        ],
        series: this.optionData.series,
      },
    }
  },
}
</script>
<style scoped>
.echarts {
  width: 100%;
  height: 400px;
}
</style>
